module.exports = __webpack_public_path__ + "img/photo_240720778_2.15f679fc.jpg";